import Logger from '../toolkit/logger/Logger';
import Login from '../components/auth/Login';
import Users from '../components/user/Users';
import Home from '../components/dashboard/Home';
import Logout from '../components/common/Logout';
import Sensors from '../components/sensor/Sensors';
import EditUser from '../components/user/EditUser';
import GraphPage from '../components/sensor/GraphPage';
import CreateUser from '../components/user/CreateUser';
import EditGroupsPage from '../components/group/EditGroupsPage';
import EditSensor from '../components/sensor/EditSensor';
import ManageGroups from '../components/group/ManageGroups';
import FirmwarePage from '../components/firmware/FirmwarePage';
import ForgetPassword from '../components/auth/ForgetPassword';
import UnknownSensors from '../components/sensor/UnknownSensors';
import ResetPassword from '../components/auth/ResetPassword';
import UpdateFirmware from '../components/firmware/Update';
import CreateSensor from '../components/sensor/CreateSensor';
import AlarmPage from '../components/alert/AlarmPage';
import AlertListPage from '../components/alert/AlertListPage';
import ProtectedRoute from '../components/common/ProtectedRoute';
import Template from '../components/template/Template';
import Collection from '../components/collection/Collection';
import EditTemplate from '../components/template/EditTemplate';
import Monitor from '../components/monitor/Monitor';
import Nowruz from '../components/events/Nowruz';
import StoragePage from '../components/storage';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

const renderLoginPage = () => {
  const token = localStorage.getItem('token');
  Logger.log('AppRouter::renderLoginPage::getToken =>', token);
  if (token) {
    return <Redirect to="/dashboard" />
  }
  return <Redirect to="/login" />
};


const AppRouter = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" component={renderLoginPage} exact />
        <Route path="/login" component={Login} exact />
        <Route path="/nowruz-1400" component={Nowruz} exact />
        <Route path="/forget-password" component={ForgetPassword} exact />
        <Route path="/reset-password" component={ResetPassword} exact />
        <Route path="/logout" component={Logout} exact />
        <ProtectedRoute path="/dashboard" component={Home} exact />
        <ProtectedRoute path="/dashboard/users" component={Users} exact />
        <ProtectedRoute path="/dashboard/create-user" component={CreateUser} exact />
        <ProtectedRoute path="/dashboard/edit-user/:userId" component={EditUser} exact />
        <ProtectedRoute path="/dashboard/sensors" component={Sensors} exact />
        <ProtectedRoute path="/dashboard/unknown-sensors" component={UnknownSensors} exact />
        <ProtectedRoute path="/dashboard/graph/:sensor" component={GraphPage} exact />
        <ProtectedRoute path="/dashboard/create-sensor" component={CreateSensor} exact />
        <ProtectedRoute path="/dashboard/sensors/edit/:sensor" component={EditSensor} exact />
        <ProtectedRoute path="/dashboard/groups" component={ManageGroups} exact />
        <ProtectedRoute path="/dashboard/edit-groups" component={EditGroupsPage} exact />
        <ProtectedRoute path="/dashboard/edit-groups/:group" component={EditGroupsPage} exact />
        <ProtectedRoute path="/dashboard/groups/:groupId" component={ManageGroups} exact />
        <ProtectedRoute path="/dashboard/firmwares" component={FirmwarePage} exact />
        <ProtectedRoute path="/dashboard/firmwares/update/:firmwareId" component={UpdateFirmware} exact />
        <ProtectedRoute path="/dashboard/alarms" component={AlarmPage} exact />
        <ProtectedRoute path="/dashboard/sensor-alarms/:sensorId" component={AlertListPage} exact />
        <ProtectedRoute path="/dashboard/templates" component={Template} exact />
        <ProtectedRoute path="/dashboard/templates/:templateId" component={EditTemplate} exact />
        <ProtectedRoute path="/dashboard/collections" component={Collection} exact />
        <ProtectedRoute path="/dashboard/monitor" component={Monitor} exact />
        <ProtectedRoute path="/dashboard/storage" component={StoragePage} exact />
      </Switch>
    </BrowserRouter>
  );
};

export default AppRouter;
